import i18next from 'i18next'

export enum CallStatus {
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    INVITED = 'INVITED',
}

export const getTranslatedStatus = {
    competition: (status: string | undefined) => {
        if (!status) return 'undefined'
        return i18next.t(
            `shared:participant.competition-status.${status.toLowerCase()}`
        )
    },
    call: (status: string | undefined) => {
        if (!status) return 'undefined'
        return i18next.t(
            `shared:participant.call-status.${status.toLowerCase()}`
        )
    },
}
